import React, { useEffect, useState } from "react";
import "./AdminForm.css";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);

  const fetchMessages = async () => {
    const res = await fetch(process.env.REACT_APP_API_URL+"/adminpatnertouch");
    const data = await res.json();
    setMessages(data);
  };

  const handleDelete = async (id) => {
    await fetch(process.env.REACT_APP_API_URL+`/adminpatnertouch/${id}`, { method: "DELETE" });
    setMessages(messages.filter((msg) => msg._id !== id));
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <div className="admin-container">
      <h1>Admin Panel</h1>
      <div className="table-container">
        <h2>Stored Messages</h2>
        <table className="admin-table">
          <thead>
            <tr>
              <th>S.NO</th>
              <th>Name</th>
              <th>Email</th>
              <th>Message</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {messages.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  No messages found
                </td>
              </tr>
            ) : (
              messages.map((msg, i) => (
                <tr key={msg._id}>
                  <td>{i + 1}</td>
                  <td>{msg.name}</td>
                  <td>{msg.email}</td>
                  <td>{msg.message}</td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(msg._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
